import api from './api';

export const getConfig = async (matrizId) => {
  return await api.get(`/multiloja/barbearias/${matrizId}/config`);
};

export const setConfig = async (matrizId, payload) => {
  return await api.put(`/multiloja/barbearias/${matrizId}/config`, payload);
};

export const listFiliais = async (matrizId) => {
  return await api.get(`/multiloja/barbearias/${matrizId}/filiais`);
};

export const createFilial = async (matrizId, payload) => {
  return await api.post(`/multiloja/barbearias/${matrizId}/filiais`, payload);
};

export const addUsuarioFilial = async (filialId, payload) => {
  return await api.post(`/multiloja/barbearias/${filialId}/usuarios`, payload);
};

export default {
  getConfig,
  setConfig,
  listFiliais,
  createFilial,
  addUsuarioFilial
};








